export class Article {
    articleType: string
    createdDate: string;
    feature: boolean
    htmlContent: string;
    id: number;
    imagePath: string;
    modifiedDate:string;
    month:string;
    pdfUrl: string;
    shortDesc: string;
    thumbnailImage: string;
    title: string;
    type: string;
    video: string;
    year: string;
    translatedModifiedDate:string;
}


export class Year {
    year:string
}


export class Month {
    month:string
}

export class CategoryGroup {
    featureArticles: Article[];
    articles: Article[];
    featureArticleRows: Article[][];
    articleRows:Article[][];
    articleMap: {[key:number] : Article};
    constructor(){
        this.featureArticles = [];
        this.articles =[];
        this.featureArticleRows =[];
        this.articleRows = [];
        this.articleMap ={};
    }


    group(articles: Article[]){
        for(const article of articles){
          if(article.feature){
            this.featureArticles.push(article);
          } else{
            this.articles.push(article)
          }
          this.articleMap[article.id] = article;
        }    
        this.setArticleRow(this.featureArticles, this.featureArticleRows);
        this.setArticleRow(this.articles, this.articleRows);
    }

    public setArticleRow(articles: Article[], rows: Article[][]){
        let r = 0;
        let c =1;
        for(const article of articles){
          rows[r] =  rows[r] ?  rows[r] : [];
          rows[r].push(article);
          if(c % 2 === 0) { r++}
          c++
        }
      }

}